import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaDownload, FaWhatsapp } from "react-icons/fa";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import whatsapp from "../assets/images/whatsapp.webp";
import telegram from "../assets/images/telegram.svg";
import support from "../assets/images/support.svg";

import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isMobile } from "react-device-detect";
import FooterDropdown from "./FooterDropdown";
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const [icon, setIcon] = useState({});
  const sidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModalAccount;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getSetting, {
      website: hostname,
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div
      style={{ marginBottom: "50px" }}
      className="footer-wrap ng-star-inserted"
    >
      <footer className="footer">
        {location?.pathname == "/" && !sidebarModalAccount && !sidebarModal && (
          <>
            <div className="betbtn1">
              <>
                <div
                  onClick={() => {
                    window.open(
                      icon?.whatsappContent
                        ? "https://wa.me/" + icon?.whatsappContent
                        : "https://wa.me/+",
                      "_self",
                    );
                  }}
                >
                  <img
                    src={
                      icon?.whatsappIcon
                        ? process.env.REACT_APP_API_BASE_URL +
                          icon?.whatsappIcon
                        : whatsapp
                    }
                    alt=""
                  />
                </div>
              </>

              <div
                onClick={() => {
                  window.open(icon?.telegramContent, "_self");
                }}
              >
                <img
                  src={
                    icon?.telegramIcon
                      ? process.env.REACT_APP_API_BASE_URL + icon?.telegramIcon
                      : telegram
                  }
                  alt=""
                />
              </div>
              <div
                onClick={() => {
                  window.open("", "_self");
                }}
              >
                <img
                  src={
                    icon?.telegramIcon
                      ? process.env.REACT_APP_API_BASE_URL + icon?.telegramIcon
                      : support
                  }
                  alt=""
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="pay">
            <div
              _ngcontent-serverapp-c1907600589
              className="pay ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("PaymentMethods")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay16"
                    src="/assets/FooterNew/pay16.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay22"
                    src="/assets/FooterNew/pay22.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay33"
                    src="/assets/FooterNew/pay33.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={46}
                    height={30}
                    style={{ "aspect-ratio": "46 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay34"
                    src="/assets/FooterNew/pay34.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay45"
                    src="/assets/FooterNew/pay45.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={87}
                    height={30}
                    style={{ "aspect-ratio": "87 / 30" }}
                  />
                </li>

                {/* <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay48"
                    src="/assets/FooterNew/pay48.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={165}
                    height={30}
                    style={{ "aspect-ratio": "165 / 30" }}
                  />
                </li> */}

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay59"
                    src="/assets/FooterNew/pay59.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay60"
                    src="/assets/FooterNew/pay60.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={153}
                    height={45}
                    style={{ "aspect-ratio": "153 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay61"
                    src="/assets/FooterNew/pay61.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={39}
                    height={39}
                    style={{ "aspect-ratio": "39 / 39" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div>
        <div style={{ display: "flex", width: "100%",margin:!isMobile ? '15px 0' : '' }}>
        
          <div
            _ngcontent-serverapp-c3151814184
            className="footer-social ng-star-inserted"
            style={{}}
          >
            <h2 _ngcontent-serverapp-c3151814184>{t("CommunityWebsites")}</h2>
            <ul _ngcontent-serverapp-c3151814184>
              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="facebook"
                    fetchpriority="low"
                    src="/assets/FooterNew/facebook.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={22}
                    height={22}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>

              {/* <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="instagram"
                    fetchpriority="low"
                    src="/assets/FooterNew/instagram.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={22}
                    height={22}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li> */}

              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="telegram-channel"
                    fetchpriority="low"
                    src="/assets/FooterNew/telegram-channel.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>

              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="twitter"
                    fetchpriority="low"
                    src="/assets/FooterNew/twitter.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>
              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="instagram"
                    fetchpriority="low"
                    src="/assets/FooterNew/whatsapp-channel.png?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={22}
                    height={22}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>
            </ul>
          </div>

          <div _ngcontent-serverapp-c764753197 className="official-partner">
            <mcd-principal-sponsor
              _ngcontent-serverapp-c764753197
              _nghost-serverapp-c2304217049
            >
              <h2
                _ngcontent-serverapp-c2304217049
                className="footer__title ng-star-inserted"
              >
                Official Partner
              </h2>
              <ul
                _ngcontent-serverapp-c2304217049
                className="sponsor__items ng-star-inserted"
              >
                <li
                  _ngcontent-serverapp-c2304217049
                  className="sponsor__item ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c2304217049
                    target="_blank"
                    href="#"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c2304217049
                      className="sponsor__image"
                      alt="undefined"
                      loading="lazy"
                      src="/assets/images/official-partner-heyvip.png"
                      width={498}
                      height={150}
                      style={{ "aspect-ratio": "498 / 150" }}
                    />
                  </a>
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                  {/**/}
                </li>
                {/**/}
                {/**/}
              </ul>
              {/**/}
              {/**/}
            </mcd-principal-sponsor>
          </div>
        </div>

        <div
          className="row"
          style={{ borderTop: ".2666666667vw solid rgba(255,255,255,.5)" }}
        >
          <mcd-about-us _nghost-serverapp-c3419815403 className="about-us">
            <div
              _ngcontent-serverapp-c3419815403
              className="about-us ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c3419815403>{t("ABOUTUS")}</h2>
              <ul _ngcontent-serverapp-c3419815403>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/responsiblegambling"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ResponsibleGaming")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/privacypolicy"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("PrivacyPolicy")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/rulesandregulations"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    Ruels & Regulations
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/18"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    18+
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/aboutus"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ABOUTUS")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/kyc"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    KYC
                  </Link>
                </li>
                {/* <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3419815403
                    href="/bd/en/vip-detail"
                    className="ng-star-inserted"
                  >
                    {" "}
                    {t("VIP")}{" "}
                  </a>
                </li> */}
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/termsandconditions"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("TermsConditions")}{" "}
                  </Link>
                </li>
              </ul>
              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  onClick={() => navigate("/affiliate-link")}
                  style={{
                    color: "white",
                    background: "#e9c309",
                    border: "none",
                    borderRadius: "5px",
                    padding: "8px 10px",
                    width: "160px",
                    marginTop: "10px",
                    fontWeight: "600",
                  }}
                  className=""
                >
                  Join Affiliate To Earn
                </button>
                <button
                  onClick={() => navigate("/affiliate-link")}
                  style={{
                    color: "white",
                    background: "#4574a8",
                    border: "none",
                    borderRadius: "5px",
                    padding: "8px 10px",
                    width: "120px",
                    marginTop: "10px",
                    fontWeight: "600",
                    marginLeft: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Affiliate App{" "}
                  <FaDownload color="white" style={{ marginLeft: "5px" }} />
                </button>
              </div> */}
            </div>
          </mcd-about-us>
        </div>
        {/* <div style={{ width: "100%" }} className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="license">
            <div
              _ngcontent-serverapp-c1907600589
              className="license ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("GamingLicense")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    width={172}
                    height={56}
                    alt="license1"
                    src="/assets/Footer/license1.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    style={{ "aspect-ratio": "172 / 56" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="anjouan-egaming"
                    src="/assets/Footer/anjouan-egaming.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={142}
                    height={60}
                    style={{ "aspect-ratio": "142 / 60" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div> */}
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "start",
          }}
          _ngcontent-serverapp-c3405550557
          className="footer-bottom"
        >
          <img
            style={{ width: isMobile ? "35%" : "180px", marginRight: "10px" }}
            src={"/assets/Other/logo.png"}
          />
          <div _ngcontent-serverapp-c3405550557 className="text">
            <div _ngcontent-serverapp-c3405550557 className="title">
              Best Quality Platform
            </div>
            <p _ngcontent-serverapp-c3405550557>
              © 2026 Bhaijan9 Copyrights. All Rights Reserved
            </p>
          </div>
        </div>
        <div _ngcontent-serverapp-c3405550557 className="footer-content-area">
          <h1 _ngcontent-serverapp-c3405550557 className="slogan">
            Bhaijan9 - Top Cricket Betting &amp; Casino App
          </h1>
          <div _ngcontent-serverapp-c3405550557 className="descript">
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_1")}</p>
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_2")}</p>
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_3")}</p>
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_4")}</p>
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_5")}</p>
            <p _ngcontent-serverapp-c3405550557>{t("Footer_Line_6")}</p>
          </div>
        </div> */}

      <FooterDropdown/>
      </footer>
    </div>
  );
};

export default Footer;
